import { FC, useContext } from "react";

import { ESCALATION_EMAIL, FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";

const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor, isLogin = false }): JSX.Element => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const {changeAccordianVisibility} =  useContext(FooterContext)

  return (
    <>
      <div className="d-flex align-items-end justify-content-end">
        <div className="card p-4 pt-3 pb-3 text-end flex-fill flex-lg-grow-0">
          <button type="button" onClick={changeAccordianVisibility} className="btn btn-link text-end p-0">
            Important Safety Information
          </button>
          <a href="https://stimrouter.com/physicians/" target="_blank" className="">
            Full Prescribing Information
          </a>
          <p className="m-0 mt-3">
            {isManufacturer ? <>Escalation Email: <a href={`mailto:${ESCALATION_EMAIL}`}>
              StimRouter Escalations</a>{' '}|{' '}</> : ''}
            <span className="d-inline-block">Phone: {PHONE_NUMBER}</span>
            &nbsp;|&nbsp;
            <span className="d-inline-block">Fax: {FAX_NUMBER}</span>

          </p>
        </div>
      </div>
    </>
  );
};

export default ContactAndSafetyInfo;
